import {
  IonRow,
  IonCol,
  IonIcon,
  IonButton,
  IonText,
  IonGrid,
  IonToast,
} from "@ionic/react";
import React, { useState } from "react";
import styles from "./SocialSharingButtons.module.css";
import {
  logoTwitter,
  logoFacebook,
  link,
  shareSocialOutline,
} from "ionicons/icons";
import { HelpoDivider } from "./HelpoDivider";
import { IChallenge } from "../../models/IChallenge";

const SHARE_QUOTE = "Look I've just completed this challenge on Helpo!";
const BASE_URL = "https://helpocode19.web.app";

type ShareData = {
  title?: string;
  text?: string;
  url?: string;
  files?: ReadonlyArray<File>;
};
interface ExtendedNavigator extends Navigator {
  share: (data?: ShareData) => Promise<void>;
  canShare: (data?: ShareData) => boolean;
}

export const SocialSharingButtons = ({ Guid }: Pick<IChallenge, "Guid">) => {
  const nav = navigator as ExtendedNavigator;
  const url = window.location.toString();
  const canShare = nav.canShare && nav.share;

  const [copyURLToast, showCopyURLToast] = useState(false);
  const [shareToast, showShareToast] = useState(false);
  const [errorToast, showErrorToast] = useState(false);
  const [notSupportedToast, showNotSupportedToast] = useState(false);

  const copyToClipboard = () => {
    showCopyURLToast(true);
    // NOTE: Safari and IE are NOT supported - look into clipboard-polyfill
    nav.clipboard.writeText(url);
  };

  const share = () => {
    if (nav && canShare) {
      nav
        .share({
          url,
          title: "Helpo Challenge",
          text: "",
        })
        .then(() => {
          showCopyURLToast(true);

          return (
            <IonToast
              cssClass="ion-justify-content-center"
              isOpen={shareToast}
              onDidDismiss={() => showShareToast(false)}
              message="Shared"
              duration={400}
            />
          );
        })
        .catch((error) => {
          showErrorToast(true);

          return (
            <IonToast
              cssClass="ion-justify-content-center"
              isOpen={errorToast}
              onDidDismiss={() => showErrorToast(false)}
              message={`Error ${error}`}
              duration={400}
            />
          );
        });
    } else {
      showNotSupportedToast(true);

      return (
        <IonToast
          cssClass="ion-justify-content-center"
          isOpen={notSupportedToast}
          onDidDismiss={() => showErrorToast(false)}
          message="Sorry, your browser is not supported :("
          duration={400}
        />
      );
    }
  };

  return (
    <IonGrid>
      <IonRow
        className={
          "ion-justify-content-center " + styles.socialButtonsContainer
        }
      >
        <IonCol size="12">
          <IonText class="ion-text-center" color="primary">
            <p>SHARE</p>
            <HelpoDivider />
          </IonText>
        </IonCol>
        <IonCol size="12" sizeMd="4">
          <IonButton
            expand="block"
            className={styles.twitter}
            href={`https://twitter.com/intent/tweet?text=${SHARE_QUOTE}&url=${window.location.toString()}&hashtags=helpo,challenge`}
          >
            <IonIcon slot="icon-only" icon={logoTwitter}></IonIcon>
          </IonButton>
        </IonCol>
        <IonCol size="12" sizeMd="4">
          <IonButton
            expand="block"
            className={styles.facebook}
            onClick={() =>
              FB.ui(
                {
                  method: "share",
                  href: `${BASE_URL}/challenge/${Guid}`,
                  quote: SHARE_QUOTE,
                },
                () => {}
              )
            }
          >
            <IonIcon slot="icon-only" icon={logoFacebook}></IonIcon>
          </IonButton>
        </IonCol>
        <IonCol size="12" sizeMd="4">
          <IonButton expand="block" color="tertiary" onClick={copyToClipboard}>
            <IonIcon slot="icon-only" icon={link}></IonIcon>
          </IonButton>
          <IonToast
            cssClass="ion-justify-content-center"
            isOpen={copyURLToast}
            onDidDismiss={() => showCopyURLToast(false)}
            message="Copied URL to clipboard"
            duration={400}
          />
        </IonCol>
        {canShare && (
          <IonCol size="12" sizeMd="4">
            <IonButton expand="block" color="tertiary" onClick={share}>
              <IonIcon slot="icon-only" icon={shareSocialOutline}></IonIcon>
            </IonButton>
          </IonCol>
        )}
      </IonRow>
    </IonGrid>
  );
};
